module.exports = __webpack_public_path__ + "static/img/10.9bd7980.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/2/zh/10.png
// module id = 6XVC
// module chunks = 0